// config.js
const config = {
    EMAILJS_USERID: "1bvycBxy8XUCJLF8c",
    EMAILJS_SERVICEID: "service_qlgr36j",
    EMAILJS_TEMPLATEID: "template_a5ye1of"
};
export default config;
